<template>
  <v-data-table
    :headers="headers"
    :items="receivingOfCultivatedAbolones"
    class="elevation-1"
    :loading="isLoading"
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-btn
          color="success"
          data-cy="ReceivingOfCultivatedAbolone-button-new"
          @click="$router.push({
            name: 'processing-EditReceivingOfCultivatedAbolone'
          })"
        >
          <v-icon class="mr-2">
            {{ mdiPlus }}
          </v-icon>
          {{ $t('common.buttons.new') }}
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <TableBasicButtons :editLink="{
          name: 'processing-EditReceivingOfCultivatedAbolone',
          query: {id: item.id}
        }"
        @delete="remove(item)"
      />
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mdiPlus } from '@mdi/js';
import TableBasicButtons from '@codehq/aurora-app-core/src/components/TableBasicButtons.vue';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListReceivingOfCultivatedAbolone',
  module: 'Processing',
  components: {
    TableBasicButtons,
  },
  mixins: [loading],
  data() {
    return {
      /**
      * Icons
      */
      mdiPlus,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('receivingOfCultivatedAbolones', ['receivingOfCultivatedAbolones']),
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: this.$$t('farm'),
          value: 'farm',
        },
        {
          text: this.$$t('dateReceived'),
          value: 'dateReceived',
        },
        {
          text: this.$$t('closedVehicle'),
          value: 'closedVehicle',
        },
        {
          text: this.$$t('openContainers'),
          value: 'openContainers',
        },
        {
          text: this.$$t('inBags'),
          value: 'inBags',
        },
        {
          text: this.$$t('vehicleClean'),
          value: 'vehicleClean',
        },
        {
          text: this.$$t('totalMassReceived'),
          value: 'totalMassReceived',
        },
        {
          text: this.$$t('arrivalTemperature'),
          value: 'arrivalTemperature',
        },
        {
          text: this.$$t('vehicleTemperature'),
          value: 'vehicleTemperature',
        },
        {
          text: this.$$t('identificationCompleted'),
          value: 'identificationCompleted',
        },
        {
          text: this.$$t('gapCertified'),
          value: 'gapCertified',
        },
        {
          text: this.$$t('damangedCuts'),
          value: 'damangedCuts',
        },
        {
          text: this.$$t('damagedLesion'),
          value: 'damagedLesion',
        },
        {
          text: this.$$t('visibleParasites'),
          value: 'visibleParasites',
        },
        {
          text: this.$$t('deadLameAnimals'),
          value: 'deadLameAnimals',
        },
        {
          text: this.$$t('areAnimalsClean'),
          value: 'areAnimalsClean',
        },
        {
          text: this.$$t('chemicalsDetected'),
          value: 'chemicalsDetected',
        },
        {
          text: this.$$t('animalsForProduction'),
          value: 'animalsForProduction',
        },
        {
          text: this.$$t('commentsTransport'),
          value: 'commentsTransport',
        },
        {
          text: this.$$t('commentsMortalities'),
          value: 'commentsMortalities',
        },
        {
          text: this.$$t('numberOfMortalities'),
          value: 'numberOfMortalities',
        },
        {
          text: this.$$t('suspectedCauseOfMortality'),
          value: 'suspectedCauseOfMortality',
        },
        {
          text: this.$$t('internalVerificationCompletedForm25'),
          value: 'internalVerificationCompletedForm25',
        },
        {
          text: this.$$t('internalVerificationOfScale'),
          value: 'internalVerificationOfScale',
        },
        {
          text: this.$$t('reading'),
          value: 'reading',
        },
        {
          text: this.$$t('deviation'),
          value: 'deviation',
        },
        {
          text: this.$$t('cratesReturned'),
          value: 'cratesReturned',
        },
        {
          text: this.$$t('cratesCleaned'),
          value: 'cratesCleaned',
        },
        {
          text: this.$$t('purgingBagsContained'),
          value: 'purgingBagsContained',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_receivingOfCultivatedAbolones();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('receivingOfCultivatedAbolones', ['LOAD_receivingOfCultivatedAbolones', 'DELETE_receivingOfCultivatedAbolone']),
    /** Delete ReceivingOfCultivatedAbolone from the collection
     */
    async remove(receivingOfCultivatedAbolone) {
      this.isLoading = true;
      await this.DELETE_receivingOfCultivatedAbolone(receivingOfCultivatedAbolone.id);
      this.isLoading = false;
    },
  },
};
</script>

<docs>
# ReceivingOfCultivatedAbolone example

'''js
<ReceivingOfCultivatedAbolone />
'''
</docs>
